
import { post, fetch, Del, put } from "@/ask/axios";
import senderAddrBox from '@/components/userCenter/public/senderAddrBox.vue' //发件人地址库
import menberMenu from '@/components/userCenter/public/menberPageMenu.vue'
export default {
  components: { senderAddrBox,menberMenu},
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      titNames: "Pick-up service",
      titUrls: ",",
      queryWait:true,
      isByOrder:false, //百运下单
      haveOrder:true,
      addOrderBox:false,
      discernBox:false,
      discernBox1:false,
      startSumbit:false,
      discernInfo:'',
      discernInfo1:'',
      ordTableData:[],
      PEReqiure:'Please fill in the contact email',


      CityKey: "",
      PlanCargoDate: "",
      OrderStartDate: "",
      OrderEndDate: "",
      WayOpt:[
        {name:"ALL",val:0},
        {name:"Express",val:1},
        {name:"Air Freight",val:3},
      ],
      WaybillType:0,
      ordInfoArr:[],
      curOrdInfo:'',
      curShow:false,

      pickerOptions: {
        disabledDate: time => {
          return this.dealDisabledDate(time)
        }
      },
      // 单独下取件单
      LinkManName: '', //
      LinkTel: '', //
      Address:'', //
      LinkEmail:'', //
      DestAddress:'', //
      Remark:'', //
      Unit:'',
      LinkManNameTip: false, //
      LinkTelTip: false, //
      GoodsInfos:'',
      AddressTip:false, //
      LinkEmailTip:false, //
      DestAddressTip:false, //
      LadingNameTip:false,
      LadingPhoneTip:false,
      UnitTip:false,
      GoodsInfosTip:false,
      discernInfoTip:false,
      discernInfoTip1:false,

      LadingName:'',
      LadingPhone:'',

      disable:false,
      TwoTh:false,

      // 选是
      userThWrite:[],
      currentPage:1,
      Skip: 0,
      Take: 20,
      Total:0,
      sumCost:0,//总费用
      servTimeOptions:[],
      WaybillTypeArr:[],

      loading:false,
      pickCheck:false,
      isStartInfo:true, //是否赋值给收件人信息

      // 全选全不选
      ThcheckAll:false,
      selIndex:[],
      showNoPrice:false,
      //日期输入处理,结束日期不能大于开始日期
      pickerBeginDateBefore: {
        disabledDate: time => {
          if (this.OrderEndDate) {
            return time.getTime() > Date.now() || time.getTime() > this.OrderEndDate;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      //日期输入处理，结束日期不能大于开始日期
      pickerBeginDateAfter: {
        disabledDate: time => {
          let startDate = new Date(this.OrderStartDate);
          return time.getTime() < startDate.getTime() || time.getTime() > Date.now();
        }
      },
    }
  },
  watch: {
    userThWrite:{ //监听的对象
      deep:true, //深度监听设置为 true
      handler:function(newV,oldV){
        let falg = true
        for (let i = 0; i < newV.length; i++) {
          const ele = newV[i]
          if(!ele.PlanCargoDate) {
            falg = false
          }
        }
        this.showNoPrice = falg
      }
    },
    LinkTel: function(newVal, oldVal) {
      let fareg = /^[0-9-]+$/
      if(!fareg.test(newVal)  && newVal!=''){
        this.LinkTel = oldVal
      }
    },
    LadingPhone: function(newVal, oldVal) {
      let fareg = /^[0-9-]+$/
      if(!fareg.test(newVal)  && newVal!=''){
        this.LadingPhone = oldVal
      }
    }
  },
  created() {
    // 获取预约时间
    this.addReceiveAPIInfo()
    this.PlanCargoDate = new Date(this.$route.query.PlanDate).Format('yyyy-MM-dd')+' 23:59:59'
    this.CityKey =  this.$route.query.StartCityKey
    let SupplierCode =  this.$route.query.SupplierCode
    this.startSetServTimeApi(this.$route.query.THFreightKey)
    if(SupplierCode == 'BSA00317') {
      this.disable = true
      this.isByOrder = true
      this.changIsBy()
    }
    this.datetime()
  },
  methods: {
    addReceiveAPIInfo(){
      this.api.param={}
      // this.api.url=this.$api02+'/api/EbayCustomer/Addresser/List';
      this.api.url=this.$api04 + '/Basics/api/Addresser/List';
      post(this.api.url,this.api.param).then( (res)=> {
        if(res.Results){
          var arr = res.Results
          //console.log(arr)
          arr  = arr.filter((x)=>{
            return x.Address_IsDefault/* 筛选默认数据 */
          })

          if(arr[0]) {
            if(arr[0].City_Key == this.CityKey) {
              this.LinkManName =arr[0].Address_Name
              this.LinkTel =arr[0].Address_Tel
              this.Address =arr[0].Address_Street+arr[0].Address_City+arr[0].Address_ZIPCode+arr[0].Address_Country
              this.LinkEmail = arr[0].Address_Mail
            }
          }
        }
      })
    },
    dealDisabledDate(time) {
      let flag = true
      for (let i = 0; i < this.servTimeOptions.length; i++) {
        const ele = this.servTimeOptions[i]
        if(time.getFullYear() == new Date(ele.Date).getFullYear()
        && time.getMonth() == new Date(ele.Date).getMonth()
        && time.getDate() == new Date(ele.Date).getDate()) {
          flag = false
        }
      }
      return flag
    },
    EmailBlur() {
      var emailReg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!emailReg.test(this.LinkEmail)) {
        this.PEReqiure = 'Please enter a valid email address'
      }
    },
    //发件人地址栏弹框
    clkSendAddrBox(flag){
      this.isStartInfo = flag
      // 1 代表是收件人信息  2 代表是收件人信息
      this.$refs.senderBox.clkDialog();
    },
    //发件人地址库点击选择按钮
    showMsgSender(msg){
      if(this.isStartInfo) {
        this.LinkManName =msg.Address_Name
        this.LinkTel =msg.Address_Tel
        this.Address =msg.Address_Street+' ,'+msg.Address_City+' ,'+msg.Address_ZIPCode+' ,'+msg.Address_Country
        this.LinkEmail = msg.Address_Mail
      } else {
        this.LadingName = msg.Address_Name
        this.LadingPhone = msg.Address_Tel
        this.DestAddress  =msg.Address_Street+' ,'+msg.Address_City+' ,'+msg.Address_ZIPCode+' ,'+msg.Address_Country
      }
    },
    // 全选和全不选
    isCheckAll(val) {
      let set = `${val}Sel`
      let data =  `${val}All`
      if(this[data]) {
        this.ordTableData.forEach(item => {
          if(item.ServiceCode == 0) {
            item[set] = true
            this.selIndex.push(item.WaybillNO)
          }
        })
      } else {
        this.ordTableData.forEach(item => {
          var index = this.selIndex.indexOf(item.WaybillNO)
          this.selIndex.splice(index,1);
          item[set] = false
        })
      }
    },
    knowIsCheck(WaybillNO,index) {
      let checkAll = true
      if(this.ordTableData[index].ThcheckSel) {
        this.selIndex.push(WaybillNO)
      } else {
        var index = this.selIndex.indexOf(WaybillNO)
        this.selIndex.splice(index,1);
      }
      for (let i = 0; i < this.ordTableData.length; i++) {
        const ele = this.ordTableData[i]
        if(!ele.ThcheckSel) {
          checkAll = false
        }
      }
      this.ThcheckAll = checkAll
    },
    //  默认赋值12点
    getPlanDate(index) {
      this.PlanCargoDate =  new Date(this.PlanCargoDate).Format('yyyy-MM-dd')+' 23:59:59'
      if(index) {
        this.cascader(index-1)
      }
    },
    cascader(index) {
      this.loading = false
      //console.log(this.userThWrite[index].PlanCargoDate)
      let PlanDate = this.userThWrite[index].PlanCargoDate
      let arr = []
      for (let i = 0; i < this.ordInfoArr[index].OrdersList.length; i++) {
        const ele = this.ordInfoArr[index].OrdersList[i]
        arr.push(ele.WaybillNO)
      }
      let flag = false
      for (let i = 0; i < this.userThWrite.length; i++) {
        const ele = this.userThWrite[i];
        if(!ele.PlanCargoDate) {
          ele.PlanCargoDate = PlanDate
          flag = true
          for (let j = 0; j < this.ordInfoArr[i].OrdersList.length; j++) {
            const elj = this.ordInfoArr[i].OrdersList[j]
            arr.push(elj.WaybillNO)
          }
        }
      }
      if(flag) {
        this.makePickUpApi(arr,true,PlanDate)
      } else {
        arr = []
        for (let i = 0; i < this.ordInfoArr[index].OrdersList.length; i++) {
          const ele = this.ordInfoArr[index].OrdersList[i]
          arr.push(ele.WaybillNO)
        }
        this.makePickUpApi(arr,true,PlanDate)
      }
    },

    // 分页
    handleSizeChange(val) {
      this.currentPage = 1
      this.Skip = 0
      this.Take = val
      this.getCargoQuery()
    },
    handleCurrentChange(val) {
      this.Skip = (val-1)*this.Take
      this.getCargoQuery()
    },
    pickAddr() {
      if(!this.discernInfo) {
        this.discernInfoTip = true
        return false
      }
      this.api.url = this.$api02 + '/api/EbayCustomer/PickupAddr/DiscernEn'
      this.api.param = {
        "textbox": this.discernInfo
      }
      fetch(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.LinkManName = res.Results.FullName
          this.LinkTel = res.Results.Phone
          this.Address = res.Results.Address
          this.LinkEmail =  res.Results.Mailbox
        }
      });
      // 结束
      this.discernBox = false
    },
    pickAddr1() {
      if(!this.discernInfo1) {
        this.discernInfoTip1 = true
        return false
      }
      this.api.url = this.$api02 + '/api/EbayCustomer/PickupAddr/DiscernEn'
      this.api.param = {
        "textbox": this.discernInfo1
      }
      fetch(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.LadingName = res.Results.FullName
          this.LadingPhone = res.Results.Phone
          this.DestAddress = res.Results.Address
        }
      });
      // 结束
      this.discernBox1 = false
    },

    // api
    leaveInfo () {
      this.curShow= false
    },

    // 验证
    falseZero(val) {
      if(this[val] == 0) {
        this[val] = ''
      }
    },
    LinkTelBlur(val) {
      if( !(/^[0-9-]+$/.test(this[val]) )) {
        this[val] = ''
      }
    },
    getPickDetail(WaybillNO) {
      this.api.url = this.$api03 + '/api/PickupOrders/CargoByBillNO'
      this.api.param = {
        "WaybillNO": WaybillNO
      }
      fetch(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.curOrdInfo = res.Results
          this.curShow = true
        }
      });
    },
    changIsBy() {
      if(this.isByOrder) {
        this.addOrderBox=true
        this.queryWait = true
        this.getCargoQuery()
      }
    },
    //1快递 ，2 小包 ，3 空运，4海运整柜，5海运散货,20 FBA头程
    typeConversion(val){
      if(val==1) return'Express'
      if(val==3) return'Air Freight'
      if(val==20) return'FBA头程'
    },
    addDate(date,days){
      date = date.join(' ')
      var d=new Date(date);
      d.setDate(d.getDate()+days);
      var m=d.getMonth()+1;
      return d.getFullYear()+'-'+m+'-'+d.getDate();
    } ,
    getServTimeApi(THFreightKey,ChargeWeight) {
      let THKey = ''
      if(THFreightKey) {
       THKey = THFreightKey
      } else {
        THKey = this.$route.query.THFreightKey
      }
      let that=this
      if(ChargeWeight) {
        this.api.param={
          startCityKey:this.$route.query.StartCityKey,
          // endCityKey:this.$route.query.EndCityKey,
          tHFreightKey:THKey,
          channelType:1,
          ChargeWeight:ChargeWeight
        }
      } else {
        this.api.param={
          startCityKey:this.$route.query.StartCityKey,
          // endCityKey:this.$route.query.EndCityKey,
          tHFreightKey:THKey,
          channelType:1,
        }
      }
      // this.api.url=this.$api01+"/api/InfoCustomer/PickupChannel/ServiceTimeEn"
      this.api.url=this.$api04 + "/Pickup/api/PickupChannel/ServiceTimeEn"
      return new Promise((resolve, reject) => {
        fetch(that.api.url, that.api.param).then(res => {
          if (res.IsOK) {
            resolve(res.Results);
          }
        });
      });
    },
    async setServTimeApi(THFreightKey,ChargeWeight){
      this.servTimeOptions= []
      let res = await this.getServTimeApi(THFreightKey,ChargeWeight)
      this.servTimeOptions= res
      // 当前时间选择里可选择的时间
    },
    // 一开始的
    async startSetServTimeApi(THFreightKey){
      let res = await this.getServTimeApi(THFreightKey)
      this.servTimeOptions= res
    },

    cancel() {
      this.loading = true
      this.addOrderBox=false
    },
    getCargoQuery() {
      this.addOrderBox=true
      this.queryWait = true
      // this.api.url = this.$api03 + '/api/TradeCustomer/PickupOrders/CargoQuery'
      this.api.url = this.$api04 + '/Pickup/api/PickupOrderQuery/CargoQuery';
      this.api.param = {
        "CityKey": this.CityKey,
        "PlanCargoDate":  new Date(this.PlanCargoDate).Format('yyyy-MM-dd')+' 23:59:59' ,
        "WaybillType": this.WaybillType,
        "OrderStartDate":new Date(this.OrderStartDate).Format('yyyy-MM-dd hh:mm:ss'),
        "OrderEndDate": new Date(this.OrderEndDate).Format('yyyy-MM-dd hh:mm:ss'),
        "Skip": this.Skip,
        "Take": this.Take,
        "ChannelType": 1,
      }
      post(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.ordTableData = res.Results
          for (let i = 0; i < this.ordTableData.length; i++) {
            const ele = this.ordTableData[i];
            //判断当前选择的在列表是否已选择  因为接口是分页类  所以需要判断
            if(this.selIndex.indexOf(ele.WaybillNO)!== -1) {
              ele.ThcheckSel = true
            } else {
              ele.ThcheckSel = false
            }
            ele.ordNo = this.Skip+i+1
          }
          this.Total = Number(res.Total)
          this.queryWait = false
        }
      });
    },
    // 自动赋值一个月期间时间
    datetime() {
      this.OrderEndDate  = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);
      let OrderStartDate = new Date(new Date().setMonth(this.OrderEndDate.getMonth()-1))
      this.OrderStartDate = new Date(new Date(new Date(OrderStartDate).toLocaleDateString()).getTime());
    },

    blur() {
      // this.LinkManNameTip = true
      this.LinkTelTip = true
      // this.LadingNameTip= true
      // this.LadingPhoneTip= true
      // this.AddressTip = true
      // this.DestAddressTip = true
      this.UnitTip = true
      this.LinkEmailTip = true
      for (let i = 0; i < this.userThWrite.length; i++) {
        const ele = this.userThWrite[i];
        ele.PlanCargoDateTip = true
      }
    },
    // 去掉取件单
    reduceWay(WaybillNO,PlanCargoDate) {
      this.$confirm('Are you sure you want to delete this order?','',  {
        customClass: "custom-message-box", //自定义添加Class
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
        closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
        center: true
        }).then(() => {
          this.loading = false
          if(!PlanCargoDate) {
            PlanCargoDate = this.PlanCargoDate
          }
          var WaybillArr = JSON.parse(JSON.stringify(this.WaybillTypeArr))
          var index = WaybillArr.indexOf(WaybillNO)
          WaybillArr.splice(index,1)
          if(WaybillArr.length == 0) {
            this.ordInfoArr = []
            this.sumCost = 0
            this.loading = true
          } else {
            this.deleteApi(WaybillArr,PlanCargoDate)
          }
        }).catch(() => {
      });
    },
    //删除查询
    deleteApi(WaybillTypeArr,PlanCargoDate) {
      let  WayArr = WaybillTypeArr
      let  PlanDate = PlanCargoDate
      this.api.url = this.$api01 + '/api/PickupChannel/Make'
      this.api.param = {
        "CityKey":this.$route.query.StartCityKey,
        "PlanCargoDate": new Date(PlanDate).Format('yyyy-MM-dd')+' 23:59:59',
        "ChannelType": 1,
        "WaybillNO":WayArr,
      }
      post(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.WaybillTypeArr = WayArr
          this.sumCost = 0
          this.ordInfoArr = res.Results
          this.loading = true
          // 更改提货时间查询
          for (let i = 0; i < this.ordInfoArr.length; i++) {
            const ele = this.ordInfoArr[i];
            this.sumCost += Number(ele.PickupFee)
          }
          this.addOrderBox=false
        } else {
          if(res.ErrorCode == 'H0001') {
            this.$alert( 'The order you selected is overweight. Please place multiple orders.','',  {
                customClass:'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                center: true
              }).then(() => {
                this.loading = true
              }).catch(() => {
                this.loading = true
            });
          } else {
            this.$alert('fail','',  {
                customClass:'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                center: true
                }).then(() => {
                  this.loading = false
                }).catch(() => {
              });
          }
        }
      });
    },
    // 分取件单
    makePickUp() {
      this.loading = false
      let WaybillTypeArr = this.selIndex
      this.WaybillTypeArr = WaybillTypeArr
      this.makePickUpApi()
    },
    //分类取件单  Query 代表查询
    makePickUpApi(WaybillTypeArr,Query,PlanCargoDate) {
      let WayArr = []
      let PlanDate = ''
      if(WaybillTypeArr) {
        WayArr = WaybillTypeArr
      } else {
        WayArr = this.WaybillTypeArr
      }
      if(PlanCargoDate) {
        PlanDate = PlanCargoDate
      } else {
        PlanDate = this.PlanCargoDate
      }
      this.api.url = this.$api01 + '/api/PickupChannel/Make'
      this.api.param = {
        "CityKey":this.$route.query.StartCityKey,
        "PlanCargoDate": new Date(PlanDate).Format('yyyy-MM-dd')+' 23:59:59' ,
        "ChannelType":1,
        "WaybillNO":WayArr,
      }
      post(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {
          this.sumCost = 0
          this.loading = true
          // 更改提货时间查询
          if(Query) {
            for (let i = 0; i < res.Results.length; i++) {
              for (let j = 0; j < this.ordInfoArr.length; j++) {
                //console.log(res.Results[i].WareID , this.ordInfoArr[j].WareID)
                if(res.Results[i].WareID == this.ordInfoArr[j].WareID) {
                  this.ordInfoArr[j] = res.Results[i]
                }
              }
            }
            for (let i = 0; i < this.ordInfoArr.length; i++) {
              const ele = this.ordInfoArr[i];
              this.sumCost += Number(ele.PickupFee)
            }
          } else {
            this.ordInfoArr = res.Results
            this.userThWrite = []
            let PlanCargoDate = this.PlanCargoDate
            for (let i = 0; i < this.ordInfoArr.length; i++) {
              const ele = this.ordInfoArr[i];
              this.sumCost += Number(ele.PickupFee)
              var PlanArrDate = new Date(new Date(new Date(this.PlanCargoDate).setDate(new Date(this.PlanCargoDate).getDate()+Number(ele.WorkDays)))).Format('yyyy-MM-dd hh:mm:ss')
              this.userThWrite.push({
                PlanCargoDate:PlanCargoDate,
                PlanCargoDateTip:false,
                PlanArrDate:PlanArrDate,
                servTimeOptions:this.servTimeOptions
              })
            }
          }
          this.loading = true
          this.addOrderBox=false
        } else {
          if(res.ErrorCode == 'H0001') {
            this.$alert( 'The order you selected is overweight. Please place multiple orders.','',  {
                customClass:'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                center: true
                }).then(() => {
                  this.loading = true
                }).catch(() => {
                  this.loading = true
              });

          } else {
            this.$alert('fail','',  {
                customClass:'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                center: true
                }).then(() => {
                  this.loading = false
                }).catch(() => {
              });
          }
        }
      });
    },
   //非关联单
    sumbitPick() {
      let PlanCargoDate = this.PlanCargoDate
      let NoTime = false
      if(new Date(PlanCargoDate).getTime() < new Date().getTime()+30*60*1000 ) {
        NoTime = true
      }
      if(NoTime) {
        this.$alert( "There is no service for the current pickup time. Please reselect the pickup time",'',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
        });
      }
      if(NoTime) {
        return false
      }
      this.blur()
      // if( !this.LinkManName || !(this.LinkTel || this.LinkEmail) ||
      //     !this.Address ||!this.DestAddress ||
      //     !this.Unit  ||!this.LadingName ||!this.LadingPhone ) {
      //   return false
      // }
      if( !(this.LinkTel || this.LinkEmail)) {
        this.PEReqiure = 'Phone or email required'
      }
      // if( !(this.LinkTel || this.LinkEmail) ||  !this.Unit   ) {
        if( !(this.LinkTel || this.LinkEmail) ) {
        return false
      }
      this.startSumbit = true
      this.api.url = this.$api03 + '/api/TradeCustomer/PickupOrdersEnglish/PickupAddOrderOnlyEn'
      this.api.param = {
        "THFreightKey": this.$route.query.THFreightKey,
        "Remark": this.Remark,
        "PickupFee": Number(this.$route.query.PickupFee).toFixed(2),
        "Weight":this.$route.query.ChargeWeight,
        "Volume": this.$route.query.Volume,
        // "Quantity":this.Unit,
        "ConnectInfo": {
          "LinkManName": this.LinkManName, //
          "LinkTel": this.LinkTel, //
          "Address":this.Address, //
          "DestAddress":this.DestAddress, //
          "Remark":this.Remark, //
          "LinkEmail":this.LinkEmail, //
          "PlanCargoDate":new Date(this.PlanCargoDate).Format('yyyy-MM-dd')+' 23:59:59',//
          "PlanArriveDate":this.$route.query.ArrivalTime,//
          "DestContactMobile": this.LadingPhone,
          "DestContactName": this.LadingName,
          "CityKey":this.$route.query.StartCityKey,
          "AreaKey": this.$route.query.StartCityAreaKey,
          "DestCityAreaKey":this.$route.query.EndCityAreaKey,
          "DestCityKey":this.$route.query.EndCityKey,
        },
        "GoodsInfos":[""]
      }
      post(this.api.url, this.api.param).then(res => {
        if(res.IsOK) {

          // this.submitOrder(res.Results.THBillNo,this.$route.query.PickupFee,'','Pick-up service ',this.$route.query.startCityNameEn,'',this.$route.query.endCityNameEn,'',
          // '',this.$route.query.Weight,this.$route.query.Volume,
      
          // this.$route.query.ChargeWeight,'','',this.$route.query.PickupFee,'','',false)

          this.startSumbit = false
          let list = [res.Results]
          sessionStorage.setItem('urlList', JSON.stringify({list:list,ordNumCost:this.$route.query.PickupFee}))
          this.$router.push({path: '/pickUp/PickupOrderSucceed'})
        } else {
          this.startSumbit = false
          this.$alert('fail','',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            center: true
            }).then(() => {
            }).catch(() => {
          });
        }
      });
    },
    // 新建取件单  国际单
    linkOrdSumbit() {
      if(this.ordInfoArr.length<1) {
        this.$alert( 'Please select an international order','',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
        });
      }
      this.blur()
      let goodYz = false
      let NoTime = false
      for (let i = 0; i < this.userThWrite.length; i++) {
        const ele = this.userThWrite[i];
        if(!ele.PlanCargoDate) {
          goodYz = true
        }
        if(new Date(new Date(ele.PlanCargoDate).Format('yyyy-MM-dd')+' 23:59:59').getTime() < new Date().getTime()+30*60*1000 ) {
          NoTime = true
        }
      }
      if(NoTime) {
        this.$alert( "There is no service for the current pickup time. Please reselect the pickup time",'',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: 'Confirm',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          center: true
          }).then(() => {
          }).catch(() => {
        });
      }
      if(NoTime) {
        return false
      }
      if( !(this.LinkTel || this.LinkEmail)) {
        this.PEReqiure = 'Phone or email required'
      }
      if(!(this.LinkTel || this.LinkEmail) ||  this.ordInfoArr.length<1 || goodYz ) {
        return false
      }
      this.api.url = this.$api03 + '/api/TradeCustomer/PickupOrdersEnglish/AddOrderWithWaybill'
      let orderListParam = []
      this.api.param = {}
      this.startSumbit = true
      for (let i = 0; i < this.ordInfoArr.length; i++) {
        const ele = this.ordInfoArr[i];
        orderListParam.push({
          "WareID": ele.WareID,
          "GoodsInfos": [""],
          "GoodsInfo": ele.OrdersList,
          "FileInfoList": [],
          "THFreightKey": ele.THFreightKey,
          "Remark": this.Remark,
          "PickupFee": ele.PickupFee,
          "ConnectInfo": {
            "LinkManName": this.LinkManName, //
            "LinkTel": this.LinkTel, //
            "Address":this.Address, //
            "DestAddress":this.DestAddress, //
            "Remark":this.Remark, //
            "LinkEmail":this.LinkEmail, //
            "PlanCargoDate":new Date(this.userThWrite[i].PlanCargoDate).Format('yyyy-MM-dd')+' 23:59:59',//
            "PlanArriveDate":this.userThWrite[i].PlanArrDate,//
            "AreaKey": this.$route.query.StartCityAreaKey,
            "DestCityAreaKey":this.$route.query.EndCityAreaKey,
            "CityKey":this.$route.query.StartCityKey,
            "DestCityKey":this.$route.query.EndCityKey,
            "DestContactMobile": "",
            "DestContactName": "",
          },
        })
      }
      this.api.param.OrderList  = orderListParam
      post(this.api.url, this.api.param).then(res => {







        if(res.IsOK) {
          this.startSumbit = false
          let GoodsInfos = ''
          for (let i = 0; i < this.userThWrite.length; i++) {
            const ele = this.userThWrite[i];
            GoodsInfos+= ele.GoodsInfos
          }
          // sessionStorage.setItem('urlList', JSON.stringify(res.Results))
          sessionStorage.setItem('urlList', JSON.stringify({list:res.Results,ordNumCost:this.sumCost}))
          this.$router.push({path: '/pickUp/PickupOrderSucceed'})
        } else {
          this.startSumbit = false
          this.$alert( 'fail','',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            center: true
            }).then(() => {
            }).catch(() => {
          });
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/pickup/pickUpOrder.js